import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { TrendingUp, AlertTriangle, Building, MapPin, Users, Clock, ChevronRight, Filter } from 'lucide-react';
export function TrendingIssuesPage() {
  const [timeFilter, setTimeFilter] = useState('This Week');
  const [severityFilter, setSeverityFilter] = useState('All Severity');
  const trendingIssues = [{
    id: 1,
    title: 'Delayed Possession - Green Valley Phase 2',
    project: 'Green Valley Phase 2',
    developer: 'ABC Developers',
    location: 'Hinjewadi, Pune',
    category: 'Possession Delay',
    postCount: 24,
    affectedBuyers: 156,
    views: 1847,
    trend: '+45%',
    severity: 'high',
    lastUpdate: '2 hours ago',
    description: 'Multiple buyers reporting possession delays of 18+ months beyond promised delivery date. Developer citing regulatory approvals but no concrete timeline provided.'
  }, {
    id: 2,
    title: 'Missing Infrastructure Promises',
    project: 'Sunrise Heights',
    developer: 'XYZ Constructions',
    location: 'Whitefield, Bangalore',
    category: 'Infrastructure',
    postCount: 18,
    affectedBuyers: 89,
    views: 1432,
    trend: '+32%',
    severity: 'medium',
    lastUpdate: '5 hours ago',
    description: 'Promised amenities including clubhouse, swimming pool, and landscaping not delivered. Developer has stopped responding to buyer queries.'
  }, {
    id: 3,
    title: 'Unauthorized Construction Charges',
    project: 'Metro Residency',
    developer: 'Metro Builders',
    location: 'Gurgaon',
    category: 'Financial',
    postCount: 15,
    affectedBuyers: 67,
    views: 1156,
    trend: '+28%',
    severity: 'high',
    lastUpdate: '1 day ago',
    description: 'Developer demanding additional charges not mentioned in original agreement. Buyers facing threats of possession denial if charges not paid.'
  }, {
    id: 4,
    title: 'Water Supply Issues - Ongoing',
    project: 'Lake View Plots',
    developer: 'Lake Developers',
    location: 'Pune',
    category: 'Infrastructure',
    postCount: 12,
    affectedBuyers: 45,
    views: 892,
    trend: '+18%',
    severity: 'medium',
    lastUpdate: '2 days ago',
    description: 'No municipal water connection despite 3 years of possession. Buyers forced to rely on expensive tanker water.'
  }, {
    id: 5,
    title: 'Missing Occupancy Certificate',
    project: 'Green Meadows',
    developer: 'Meadow Constructions',
    location: 'Bangalore',
    category: 'Documentation',
    postCount: 10,
    affectedBuyers: 38,
    views: 734,
    trend: '+15%',
    severity: 'high',
    lastUpdate: '3 days ago',
    description: 'Developer handed over possession without OC. Buyers unable to get electricity connections or register properties.'
  }];
  const filteredIssues = trendingIssues.filter(issue => {
    const matchesSeverity = severityFilter === 'All Severity' || issue.severity === severityFilter.toLowerCase();
    return matchesSeverity;
  });
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-1977">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-1978">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-1979">
          <Link to="/" className="flex items-center gap-2" data-id="element-1980">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-1981"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-1982">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-1983">
            <Link to="/" data-id="element-1984">Buy Plots</Link>
            <Link to="/advocacy" data-id="element-1985">Advocacy</Link>
            <Link to="/advocacy/trending" className="text-[#1f2933]" data-id="element-1986">
              Trending
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12 w-full" data-id="element-1987">
        {/* Breadcrumb */}
        <div className="mb-6" data-id="element-1988">
          <Link to="/advocacy" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-1989">
            Advocacy
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-1990">/</span>
          <span className="text-sm text-gray-900" data-id="element-1991">Trending Issues</span>
        </div>

        {/* Header */}
        <div className="mb-8" data-id="element-1992">
          <h1 className="text-4xl font-bold mb-4 flex items-center gap-3" data-id="element-1993">
            <TrendingUp className="w-10 h-10 text-gray-400" data-id="element-1994" />
            Trending Issues
          </h1>
          <p className="text-lg text-gray-500 font-mono" data-id="element-1995">
            Most reported and viewed advocacy issues this week
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white border border-gray-300 p-4 mb-8 flex gap-4" data-id="element-1996">
          <select value={timeFilter} onChange={e => setTimeFilter(e.target.value)} className="px-4 py-2 border border-gray-300 bg-gray-50 text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-1997">
            <option data-id="element-1998">This Week</option>
            <option data-id="element-1999">This Month</option>
            <option data-id="element-2000">Last 3 Months</option>
            <option data-id="element-2001">All Time</option>
          </select>
          <select value={severityFilter} onChange={e => setSeverityFilter(e.target.value)} className="px-4 py-2 border border-gray-300 bg-gray-50 text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2002">
            <option data-id="element-2003">All Severity</option>
            <option data-id="element-2004">High</option>
            <option data-id="element-2005">Medium</option>
          </select>
        </div>

        {/* Trending Issues List */}
        <div className="space-y-6" data-id="element-2006">
          {filteredIssues.map((issue, index) => <div key={issue.id} className="bg-white border border-gray-300 p-8 hover:shadow-md transition-shadow" data-id="element-2007">
              <div className="flex items-start gap-6" data-id="element-2008">
                {/* Rank */}
                <div className="text-center shrink-0" data-id="element-2009">
                  <div className="w-12 h-12 bg-gray-100 border border-gray-300 flex items-center justify-center" data-id="element-2010">
                    <span className="text-2xl font-bold text-gray-400" data-id="element-2011">
                      #{index + 1}
                    </span>
                  </div>
                  <div className="mt-2 text-xs font-bold text-green-600" data-id="element-2012">
                    {issue.trend}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1" data-id="element-2013">
                  <div className="flex items-start justify-between mb-3" data-id="element-2014">
                    <div className="flex-1" data-id="element-2015">
                      <div className="flex items-center gap-2 mb-3" data-id="element-2016">
                        <span className={`px-2 py-0.5 text-xs font-bold rounded ${issue.severity === 'high' ? 'bg-red-100 text-red-800 border border-red-200' : 'bg-yellow-100 text-yellow-800 border border-yellow-200'}`} data-id="element-2017">
                          {issue.severity === 'high' ? 'HIGH SEVERITY' : 'MEDIUM SEVERITY'}
                        </span>
                        <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-2018">
                          {issue.category}
                        </span>
                      </div>
                      <Link to={`/advocacy/trending/${issue.id}`} className="text-2xl font-bold hover:text-blue-600 block mb-3" data-id="element-2019">
                        {issue.title}
                      </Link>
                      <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-2020">
                        {issue.description}
                      </p>
                    </div>
                  </div>

                  {/* Project Info */}
                  <div className="flex items-center gap-6 mb-4 text-sm text-gray-600" data-id="element-2021">
                    <span className="flex items-center gap-2" data-id="element-2022">
                      <Building className="w-4 h-4" data-id="element-2023" />
                      <span className="font-bold" data-id="element-2024">{issue.project}</span>
                    </span>
                    <span className="flex items-center gap-2" data-id="element-2025">
                      <MapPin className="w-4 h-4" data-id="element-2026" />
                      {issue.location}
                    </span>
                    <span className="text-gray-500" data-id="element-2027">by {issue.developer}</span>
                  </div>

                  {/* Stats */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-2028">
                    <div className="flex items-center gap-6 text-sm" data-id="element-2029">
                      <span className="flex items-center gap-2" data-id="element-2030">
                        <AlertTriangle className="w-4 h-4 text-gray-400" data-id="element-2031" />
                        <span className="font-bold" data-id="element-2032">
                          {issue.postCount}
                        </span>{' '}
                        posts
                      </span>
                      <span className="flex items-center gap-2" data-id="element-2033">
                        <Users className="w-4 h-4 text-gray-400" data-id="element-2034" />
                        <span className="font-bold" data-id="element-2035">
                          {issue.affectedBuyers}
                        </span>{' '}
                        affected buyers
                      </span>
                      <span className="flex items-center gap-2 text-gray-500" data-id="element-2036">
                        <Clock className="w-4 h-4" data-id="element-2037" />
                        Updated {issue.lastUpdate}
                      </span>
                    </div>
                    <Link to={`/advocacy/trending/${issue.id}`} className="text-sm font-bold text-blue-600 hover:underline flex items-center gap-1" data-id="element-2038">
                      View Details <ChevronRight className="w-4 h-4" data-id="element-2039" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <div className="mt-12 bg-blue-50 border border-blue-200 p-8 text-center" data-id="element-2040">
          <h3 className="text-xl font-bold mb-3" data-id="element-2041">Facing a Similar Issue?</h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-2042">
            Share your experience to help other buyers and contribute to
            collective advocacy efforts.
          </p>
          <Link to="/advocacy/submit" className="inline-block px-8 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2043">
            Submit Your Advocacy Post
          </Link>
        </div>
      </main>

      <Footer data-id="element-2044" />
    </div>;
}